import { COLORS } from '@btime/constants'
import { State, appendOrRemoveValueWith } from '@btime/state-monad'
import { useOnStopTypingState, useEffectAfterMount } from '@btime/react-hooks'
import React from 'react'
import { prop } from 'ramda'
import { Text } from '../presentation/Text'
import Button from '../actions/Button'
import Checkbox from '../shapes/Checkbox'
import FlexGrid, { FlexCol } from '../structure/FlexGrid'
import Link from '../actions/Link'
import Radio from '../shapes/Radio'
import Separator from '../helpers/Separator'

// DEPRACATED
const MarkerSelector = ({ option, onClick, selected, selectedColor, useCheckbox }) => {
  const Marker = useCheckbox ? Checkbox : Radio
  return (
    <Link block onClick={onClick}>
      <FlexGrid gutter={0.2}>
        <div>
          <Marker active={selected} />
        </div>
        <Text>{option.label}</Text>
        <div>
          <Separator vertical />
        </div>
      </FlexGrid>
    </Link>
  )
}

const TagSelector = ({ option, onClick, selected, selectedColor }) => {
  const finalSelectedColor = option.selectedColor || selectedColor
  const color = selected ? finalSelectedColor : COLORS.dark3

  return (
    <FlexCol>
      <Button onClick={onClick} block medium color={color} transparent={!selected} minWidth="small" thin>
        {option.label}
      </Button>
    </FlexCol>
  )
}

const checkIfIsSelected = (selectedValue, idField) => item => {
  return (
    item === selectedValue || //
    (!!prop(idField, item) && prop(idField, item) === prop(idField, selectedValue))
  )
}

// DEPRACATED
// TODO: Remove after moved all to Picker
const TagPicker = ({
  width,
  options,
  onChange,
  onStopChanging,
  value,
  selectedColor,
  multiple,
  minWidth,
  useMarker,
  justify,
  align,
  Selector,
  idField
}) => {
  const [localValue, setLocalValue] = useOnStopTypingState(value, onStopChanging, 100)

  useEffectAfterMount(() => {
    if (value !== localValue) {
      setLocalValue(value)
    }
  }, [value])

  // TODO: Use generateOnPickerChange from @btime/helpers
  const handleChange = (selectedValue, label, item) => () => {
    if (!multiple) {
      setLocalValue(selectedValue)
      if (!onChange) return
      if (value === selectedValue) {
        onChange(undefined, '', { origin: {} })
      } else {
        onChange(selectedValue, label, item)
      }
      return
    }

    const newValue = State.of(value || [])
      .map(appendOrRemoveValueWith(checkIfIsSelected(selectedValue, idField), selectedValue))
      .fold()
    setLocalValue(newValue)
    onChange && onChange(newValue, selectedValue, label, item.origin)
  }

  Selector = Selector || (useMarker ? MarkerSelector : TagSelector)
  selectedColor = selectedColor || COLORS.purple

  return (
    <FlexGrid wrap paddingGutter={0.5} justify={justify || 'flex-center'} align={align || 'stretch'}>
      {options.map(option => {
        const selected = multiple
          ? (localValue || []).some(checkIfIsSelected(option.value, idField))
          : localValue === option.value
        return (
          <Selector
            key={option.value + prop(idField, option) + option.label}
            selected={selected}
            option={option}
            selectedColor={selectedColor}
            onClick={handleChange(option.value, option.label, option)}
            useCheckbox={multiple}
          />
        )
      })}
    </FlexGrid>
  )
}

export default TagPicker
